import { intl } from '../locales/localesConfig';
import Constants from '../definitions/constants';

//if the route is not here is allowed for all users
//before this users can get into a route not allowed by just changing the url
let permissions = {};
permissions.routes = {};
permissions.routes[Constants.app.routes.calculationUnitAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.groupAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.assignGroupAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.assignPolynomialGroupAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.assignPolynomialCalculationUnitAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.metricDataAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.calculationsActualPeriod] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.calculationsClosedPeriods] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.calculationsHistory] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.preCalculationsHistory] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.dimensionAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.polynomialAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.metricAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.virtualMetricAdmin] = [
    Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.metricsGroupAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.reportTemplateAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.assignReportTemplateGroupAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.assignReportTemplateCalculationUnitAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.biTemplateAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.userAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.endpointsConnectorsPanel] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.endpointsConnectorsAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.endpointsConnectorsVariablesAdmin] = [
  Constants.app.userRoles.ADMIN];
permissions.routes[Constants.app.routes.biCalculationsSummary] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.supervisorRevisionPanel] = [
  Constants.app.userRoles.SUPERVISOR];
permissions.routes[Constants.app.routes.supervisorsRevisionsPanelAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
permissions.routes[Constants.app.routes.exportConfigurationsAdmin] = [
  Constants.app.userRoles.ADMIN,
  Constants.app.userRoles.PERIOD_ADMIN];
  
export default permissions;



// WEBPACK FOOTER //
// ./source/definitions/permissions.js